module.exports = __webpack_public_path__ + "static/media/48.93025b3d.png";